import React from 'react';

interface IntentProgressBarProps {
  hasFavorites: boolean;
}

const STAGES = [
  { label: 'Favorito', color: '#b0324a' },
  { label: 'Visita / Asesoría', color: '#d99a2b' },
  { label: 'Oferta / Reserva', color: '#e9ecef' },
];

const IntentProgressBar: React.FC<IntentProgressBarProps> = ({
  hasFavorites,
}) => {
  const segmentColors = [
    hasFavorites ? STAGES[0].color : '#e9ecef',
    STAGES[1].color,
    STAGES[2].color,
  ];

  return (
    <div className="mt-2">
      <div className="d-flex" style={{ height: 6, borderRadius: 4, overflow: 'hidden' }}>
        {segmentColors.map((color, index) => (
          <div
            key={STAGES[index].label}
            style={{
              flex: 1,
              backgroundColor: color,
              marginLeft: index > 0 ? 2 : 0,
            }}
          />
        ))}
      </div>
      <div className="d-flex mt-1">
        {STAGES.map((stage) => (
          <div
            key={stage.label}
            className="text-muted text-uppercase font-weight-bold"
            style={{ flex: 1, fontSize: '0.6rem', lineHeight: 1.2 }}
          >
            {stage.label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default IntentProgressBar;
